export default {"src":"/_next/static/media/OPT-Primary-White.3aa6bb42.svg","height":75,"width":353,"blurWidth":0,"blurHeight":0};